'use client';

import { useMemo } from "react";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import Modal from "@/components/ui/Modal";
import { useModal } from "@/contexts/ModalContext";

const DEFAULT_NEARBY_PLACES = [
  { name: "Haşim Kültür Merkezi", distance: "0.2 km" },
  { name: "Küçük Çakıl Plajı", distance: "0.4 km" },
  { name: "Antalya Devlet Hastanesi", distance: "1.2 km" },
  { name: "Antalya Havalimanı", distance: "2.0 km" },
  { name: "Antalya Havalimanı", distance: "2.0 km" },
  { name: "Antalya Havalimanı", distance: "2.0 km" },
  { name: "Antalya Havalimanı", distance: "2.0 km" },
  { name: "Antalya Havalimanı", distance: "2.0 km" },
  { name: "Antalya Havalimanı", distance: "2.0 km" },
];

export default function NearbyPlacesSection({ places = DEFAULT_NEARBY_PLACES }) {
  const t = useTranslationDetector('hotel');
  const nearbyPlacesModal = useModal("nearby-places-modal");

  const normalizedPlaces = useMemo(() => {
    if (!Array.isArray(places) || places.length === 0) {
      return DEFAULT_NEARBY_PLACES;
    }
    return places.map((place, index) => ({
      id: place.id ?? `${place.name}-${index}`,
      name: place.name ?? "",
      distance: place.distance ?? "",
    }));
  }, [places]);

  const handleOpenModal = () => {
    nearbyPlacesModal.open({
      title: t('nearbyPlacesModalTitle'),
      size: "md",
      isBottomSheet: true,
    });
  };

  return (
    <div className="flex flex-col gap-[14px] md:gap-4 w-full min-w-0 max-w-full overflow-hidden">
      <div className="text-lg font-semibold text-foreground">{t('exploreRegion')}</div>
      <ul className="flex flex-col gap-[14px] md:gap-4 w-full min-w-0 max-w-full overflow-hidden">
        {normalizedPlaces.slice(0, 3).map((place, _index) => (
          <li key={`${place.id}-${_index}`} className="flex items-center justify-between gap-2 min-w-0 w-full max-w-full">
            <span className="text-base text-foreground truncate flex-1 min-w-0">{place.name}</span>
            <span className="text-base font-medium text-foreground whitespace-nowrap flex-shrink-0">
              {place.distance}
            </span>
          </li>
        ))}
      </ul>
      <button
        type="button"
        onClick={handleOpenModal}
        className="flex cursor-pointer items-center gap-1 text-left"
      >
        <span className="text-base font-medium text-primary">
          {t('showMore')}
        </span>
        <FontAwesomeIcon
          className="text-primary w-4! h-4!"
          fontSize={16}
          icon={byPrefixAndName.far["chevron-down"]}
        />
      </button>

      <Modal
        id="nearby-places-modal"
        className="md:!max-w-[563px]"
        contentClassName="p-6"
      >
        <div className="">
          <ul className="flex flex-col gap-5">
            {normalizedPlaces.map((place) => (
              <li
                key={`modal-${place.id}`}
                className="flex items-center justify-between gap-2 text-foreground min-w-0"
              >
                <span className="text-base truncate flex-1 min-w-0">{place.name}</span>
                <span className="text-base font-medium text-foreground whitespace-nowrap flex-shrink-0">
                  {place.distance}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </Modal>
    </div>
  );
}